interface PropsType {
  style?: React.CSSProperties;
  color?: string;
}

const MenkyoOmoteIcon = (props: PropsType) => (
  <svg width="100" height="68" viewBox="0 0 100 68" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1053_1419)">
      <path
        d="M90.6604 68H9.3396C4.19067 68 0 63.8454 0 58.737V9.26129C0 4.15457 4.18891 0 9.3396 0H90.6604C95.8093 0 100 4.15457 100 9.26129V58.737C100 63.8437 95.8111 68 90.6604 68ZM9.3396 5.73742C7.38079 5.73742 5.78661 7.31853 5.78661 9.26129V58.737C5.78661 60.6797 7.38079 62.2608 9.3396 62.2608H90.6604C92.6192 62.2608 94.2134 60.6797 94.2134 58.737V9.26129C94.2134 7.31853 92.6192 5.73742 90.6604 5.73742H9.3396Z"
        fill={props.color ? props.color : '#c3c3c3'}
      />
      <path
        d="M88.3936 51.2682C88.3989 51.0777 88.4024 50.8873 88.4024 50.6934C88.4024 42.9415 83.9528 36.6573 78.4639 36.6573C72.975 36.6573 68.5254 42.9415 68.5254 50.6934C68.5254 50.8855 68.5289 51.0777 68.5342 51.2682H88.3919H88.3936Z"
        fill={props.color ? props.color : '#c3c3c3'}
      />
      <path
        d="M78.466 20.5719C74.7827 20.5719 71.7969 23.5332 71.7969 27.1864C71.7969 30.8395 74.7827 33.8008 78.466 33.8008C82.1494 33.8008 85.1351 30.8395 85.1351 27.1864C85.1351 23.5332 82.1494 20.5719 78.466 20.5719Z"
        fill={props.color ? props.color : '#c3c3c3'}
      />
      <path d="M51.2684 38.2122H11.3223V42.3109H51.2684V38.2122Z" fill={props.color ? props.color : '#c3c3c3'} />
      <path d="M51.2684 27.41H11.3223V31.5086H51.2684V27.41Z" fill={props.color ? props.color : '#c3c3c3'} />
      <path d="M64.7106 12.8026H11.3223V20.6715H64.7106V12.8026Z" fill={props.color ? props.color : '#c3c3c3'} />
      <path
        d="M17.2716 53.1446C17.2716 54.6838 16.0139 55.9312 14.462 55.9312C12.9101 55.9312 11.6523 54.6838 11.6523 53.1446C11.6523 51.6054 12.9101 50.358 14.462 50.358C16.0139 50.358 17.2716 51.6054 17.2716 53.1446Z"
        fill={props.color ? props.color : '#c3c3c3'}
      />
      <path
        d="M25.5372 53.1446C25.5372 54.6838 24.2795 55.9312 22.7276 55.9312C21.1757 55.9312 19.918 54.6838 19.918 53.1446C19.918 51.6055 21.1757 50.358 22.7276 50.358C24.2795 50.358 25.5372 51.6055 25.5372 53.1446Z"
        fill={props.color ? props.color : '#c3c3c3'}
      />
      <path
        d="M37.5509 53.1446C37.5509 54.6838 36.2932 55.9312 34.7413 55.9312C33.1894 55.9312 31.9316 54.6838 31.9316 53.1446C31.9316 51.6055 33.1894 50.358 34.7413 50.358C36.2932 50.358 37.5509 51.6055 37.5509 53.1446Z"
        fill={props.color ? props.color : '#c3c3c3'}
      />
      <path
        d="M45.8146 53.1446C45.8146 54.6838 44.5569 55.9312 43.0049 55.9312C41.453 55.9312 40.1953 54.6838 40.1953 53.1446C40.1953 51.6054 41.453 50.358 43.0049 50.358C44.5569 50.358 45.8146 51.6054 45.8146 53.1446Z"
        fill={props.color ? props.color : '#c3c3c3'}
      />
      <path
        d="M54.0782 53.1446C54.0782 54.6838 52.8205 55.9312 51.2686 55.9312C49.7167 55.9312 48.459 54.6838 48.459 53.1446C48.459 51.6055 49.7167 50.358 51.2686 50.358C52.8205 50.358 54.0782 51.6055 54.0782 53.1446Z"
        fill={props.color ? props.color : '#c3c3c3'}
      />
    </g>
    <defs>
      <clipPath id="clip0_1053_1419">
        <rect width="100" height="68" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default MenkyoOmoteIcon;
